import { equals2 } from "fxjs/es";
import { ControllerNS } from "../../Controller/ControllerNS.js";
import { VONS } from "../../VO/VONS.js";
export class BackgroundView {
  constructor({
    background_base_el,
    background_color_el,
    background_image_el,
    background_controller,
  }) {
    this._background_base_el = background_base_el;
    this._background_color_el = background_color_el;
    this._background_image_el = background_image_el;
    background_base_el.setAttributeNS(null, "fill", "#FFFFFF");
    background_base_el.setAttributeNS(null, "stroke", "none");
    background_controller.subscribe((vo) =>
      this._observeBackgroundController(vo)
    );
  }
  _observeBackgroundController({ width, height, value }) {
    this._background_base_el.setAttributeNS(null, "width", `${width}`);
    this._background_base_el.setAttributeNS(null, "height", `${height}`);
    this._background_color_el.setAttributeNS(null, "width", `${width}`);
    this._background_color_el.setAttributeNS(null, "height", `${height}`);
    this._background_color_el.setAttributeNS(
      null,
      "opacity",
      `${value.opacity}`
    );
    this._background_image_el.setAttributeNS(null, "width", `${width}`);
    this._background_image_el.setAttributeNS(null, "height", `${height}`);
    this._background_image_el.setAttributeNS(
      null,
      "opacity",
      `${value.opacity}`
    );
    if (value.type === "color") {
      const { fill } = value;
      this._background_color_el.removeAttributeNS(null, "display");
      this._background_image_el.setAttributeNS(null, "display", "none");
      if (equals2("none")(fill)) {
        this._background_base_el.setAttributeNS(null, "display", "none");
      } else {
        this._background_base_el.removeAttributeNS(null, "display");
      }
      this._background_color_el.setAttributeNS(null, "fill", fill);
      this._background_image_el.removeAttributeNS(null, "href");
    } else if (value.type === "image") {
      const { url, data_url } = value;
      this._background_color_el.setAttributeNS(null, "display", "none");
      this._background_image_el.removeAttributeNS(null, "display");
      this._background_color_el.removeAttributeNS(null, "fill");
      this._background_image_el.setAttributeNS(null, "href", data_url);
      this._background_image_el.dataset.mpse__original_url = url;
    }
  }
}
